module.exports = __webpack_public_path__ + "assets/3641d86901e52762534bcc6d9d00b687.svg";